import React from "react";
import { getStatus } from "../taskConstants";

function StatusBadge({ status }) {
  const s = getStatus(status);
  if (!s) return null;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-Medium ${s.className}`}>
      {s.label}
    </span>
  );
}

export default StatusBadge;
